import { render, staticRenderFns } from "./DashboardSideBar.vue?vue&type=template&id=c5e4ed1c&scoped=true&lang=pug"
import script from "./DashboardSideBar.vue?vue&type=script&lang=js"
export * from "./DashboardSideBar.vue?vue&type=script&lang=js"
import style0 from "./DashboardSideBar.vue?vue&type=style&index=0&id=c5e4ed1c&prod&lang=scss"
import style1 from "./DashboardSideBar.vue?vue&type=style&index=1&id=c5e4ed1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e4ed1c",
  null
  
)

export default component.exports